import { get as _get } from "lodash";
import api from "../../helpers/api";

export const fetchApifyFilters = () => {

  return api().get("/search/apify_filter").then((res) => {
    return {
      flag: true,
      statusCode: (res.status || 200),
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      statusCode: (err.status || 400),
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching apify filters."),
      data: {}
    };
  });
}

export const initiateApifyLeadSearch = (variables) => {

  return api().post("/search/initiate_apify_lead_search", (variables || {})).then((res) => {
    return {
      flag: true,
      statusCode: (res.status || 200),
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      statusCode: (err.status || 400),
      message: _get(err, "response.data.responseMessage", "Something went wrong while initiating apify lead search."),
      data: {}
    };
  });
}

export const uploadCompanyDomainFile = (variables) => {

  return api().post("/upload/excel_sheet_headers", (variables || {}), {}).then((res) => {
    return {
      flag: true,
      statusCode: (res.status || 200),
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      statusCode: (err.status || 400),
      message: _get(err, "response.data.responseMessage", "Something went wrong while uploading company domain file."),
      data: {}
    };
  });
}
